import styles from './M38SubmoduleCategoryLinkSection.module.scss';
import classNames from 'classnames';
import { LinkButton, Paragraph, Picture, RichText } from 'ui/components';
import IconArrowRight from 'ui/icons/icon-arrow-right-web.svg';

export interface M38SubmoduleCategoryLinkSectionProps {
	className?: string;
	title?: string;
	text?: string;
	image?: {
		url: string;
		altText?: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
	};
	link?: { url: string; name?: string; target?: string };
	linkSecondary?: { url: string; name?: string; target?: string };
	linkTertiary?: { url: string; name?: string; target?: string };
	anchor?: string;
}

export const M38SubmoduleCategoryLinkSection: React.FC<M38SubmoduleCategoryLinkSectionProps> = ({
	className,
	image,
	text,
	title,
	link,
	linkSecondary,
	linkTertiary,
	anchor,
}) => {
	return (
		<section {...(anchor && { id: anchor })} className={classNames(styles.M38SubmoduleCategoryLinkSection, className)}>
			<div className={styles.M38SubmoduleCategoryLinkSection_link}>
				<div className={styles.M38SubmoduleCategoryLinkSection_image}>
					<div className={styles.M38SubmoduleCategoryLinkSection_imageBox}>
						<Picture url={image?.url} aspectRatio={0.75} className={styles.M38SubmoduleCategoryLinkSection_imageElement} />
					</div>
				</div>

				<div className={styles.M38SubmoduleCategoryLinkSection_details}>
					<Paragraph className={styles.M38SubmoduleCategoryLinkSection_name} variant="website" style="lg">
						{title}
					</Paragraph>
					<RichText content={text} variant="website" />
				</div>
				{link?.url && (
					<LinkButton
						withBackIcon={<IconArrowRight />}
						style="secondaryWeb"
						url={link.url}
						target={link?.target}
						className={styles.M5TextImage_button}
					>
						{link?.name}
					</LinkButton>
				)}
				{linkSecondary?.url && (
					<LinkButton
						withBackIcon={<IconArrowRight />}
						style="secondaryWeb"
						url={linkSecondary.url}
						target={linkSecondary?.target}
						className={styles.M5TextImage_button}
					>
						{linkSecondary?.name}
					</LinkButton>
				)}
				{linkTertiary?.url && (
					<LinkButton
						withBackIcon={<IconArrowRight />}
						style="secondaryWeb"
						url={linkTertiary.url}
						target={linkTertiary?.target}
						className={styles.M5TextImage_button}
					>
						{linkTertiary?.name}
					</LinkButton>
				)}
			</div>
		</section>
	);
};
